var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "12px",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F--V2---Web-Audit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9tail-d'une-proposition-(r\\xE9ponse-/-modification-par-le-prestataire)",
    transform: "translate(-953, -685)",
    fill: "#868F9C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(920, 620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(20, 58.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(6, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time_grey",
    transform: "translate(7, 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54583333,11 C4.78194444,11 4.06388889,10.8548611 3.39166667,10.5645833 C2.71944444,10.2743056 2.13125,9.87962963 1.62708333,9.38055556 C1.12291667,8.88148148 0.725694444,8.29583333 0.435416667,7.62361111 C0.145138889,6.95138889 0,6.23333333 0,5.46944444 C0,4.70555556 0.145138889,3.99259259 0.435416667,3.33055556 C0.725694444,2.66851852 1.12291667,2.09050926 1.62708333,1.59652778 C2.13125,1.1025463 2.71944444,0.712962963 3.39166667,0.427777778 C4.06388889,0.142592593 4.78194444,0 5.54583333,0 C6.36064815,0 7.13217593,0.178240741 7.86041667,0.534722222 C8.58865741,0.891203704 9.21759259,1.38009259 9.74722222,2.00138889 L9.74722222,0.381944444 L10.6638889,0.381944444 L10.6638889,3.55972222 L7.47083333,3.55972222 L7.47083333,2.64305556 L9.075,2.64305556 C8.62685185,2.12361111 8.09976852,1.70601852 7.49375,1.39027778 C6.88773148,1.07453704 6.23842593,0.916666667 5.54583333,0.916666667 C4.27268519,0.916666667 3.18287037,1.35208333 2.27638889,2.22291667 C1.36990741,3.09375 0.916666667,4.16064815 0.916666667,5.42361111 C0.916666667,6.71712963 1.36481481,7.81712963 2.26111111,8.72361111 C3.15740741,9.63009259 4.25231481,10.0833333 5.54583333,10.0833333 C6.81898148,10.0833333 7.89351852,9.63518519 8.76944444,8.73888889 C9.64537037,7.84259259 10.0833333,6.75787037 10.0833333,5.48472222 L11,5.48472222 C11,7.0125 10.4703704,8.31365741 9.41111111,9.38819444 C8.35185185,10.4627315 7.06342593,11 5.54583333,11 Z M7.40972222,7.99027778 L5.05694444,5.66805556 L5.05694444,2.39861111 L5.97361111,2.39861111 L5.97361111,5.28611111 L8.06666667,7.33333333 L7.40972222,7.99027778 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeGrey);
export default __webpack_public_path__ + "static/media/time_grey.0f8bec09a00d680f8257dcab49bb656e.svg";
export { ForwardRef as ReactComponent };